import {createSelector} from '@ngrx/store';
import {AppState} from '..';
import {SideMenuState} from './side-menu.reducers';


export const selectFeature = (appState: AppState) => appState.menu;

export const selectSideMenu = createSelector(
  selectFeature,
  (state: SideMenuState) => state.menu
);
export const selectTopMenu = createSelector(
  selectFeature,
  (state: SideMenuState) => state.topMenu
)
